import { ArrowRight, Phone } from "lucide-react";
import { FadeIn } from "./Reveal";
import { IMAGES } from "../../lib/images";
import { scrollToId } from "../../lib/scroll";

export default function Cta() {
    return (
        <section className="relative overflow-hidden py-28 md:py-40">
            <img
                src={IMAGES.ctaBg}
                alt=""
                aria-hidden
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-ink/85" aria-hidden />
            <div className="bg-noise pointer-events-none absolute inset-0 opacity-[0.06]" aria-hidden />
            <div className="relative mx-auto max-w-7xl px-6 md:px-12">
                <FadeIn>
                    <div className="mb-8 flex items-center gap-3">
                        <span className="h-px w-10 bg-gold" />
                        <span className="text-xs font-semibold uppercase tracking-[0.3em] text-white/60">Darmowa wycena</span>
                    </div>
                </FadeIn>
                <FadeIn delay={0.1}>
                    <h2 className="max-w-3xl font-display text-4xl font-black tracking-tighter text-white sm:text-5xl md:text-6xl">
                        Potrzebujesz sprawdzonego fachowca<span className="text-gold">?</span>
                    </h2>
                </FadeIn>
                <FadeIn delay={0.2}>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
                        Zadzwoń lub zostaw zgłoszenie — oddzwonimy w ciągu 24 godzin
                        i umówimy bezpłatną wycenę.
                    </p>
                </FadeIn>
                <FadeIn delay={0.3}>
                    <div className="mt-10 flex flex-wrap gap-4">
                        <button
                            data-testid="cta-quote-btn"
                            onClick={() => scrollToId("kontakt")}
                            className="group inline-flex items-center gap-2 rounded-full bg-gold px-9 py-4.5 font-display text-sm font-bold uppercase tracking-wider text-ink shadow-[0_14px_40px_-10px_rgba(255,179,0,0.55)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_20px_50px_-10px_rgba(255,179,0,0.7)]"
                        >
                            Umów bezpłatną wycenę
                            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                        </button>
                        <a
                            data-testid="cta-call-btn"
                            href="tel:+48512913717"
                            className="inline-flex items-center gap-2 rounded-full border border-white/25 px-9 py-4.5 font-display text-sm font-bold uppercase tracking-wider text-white transition-[background-color,border-color] duration-300 hover:border-white hover:bg-white hover:text-ink"
                        >
                            <Phone className="h-4 w-4" />
                            +48 512 913 717
                        </a>
                    </div>
                </FadeIn>
            </div>
        </section>
    );
}
